import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 20px);
    max-width: 600px;
    background-color: ${theme.white};
    margin: 10px 0;
    border-radius: 8px;
    padding: 3px 10px;
`;

const LeftSide = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 24px;
        height: 24px;
    }

    div {
        display: flex;
        flex-direction: column;
        margin-left: 10px;

        span {
            font-size: 11px;
            font-weight: 700;
            color: ${theme.textDark};
        }

        small {
            font-size: 11px;
            font-weight: 400;
            color: ${theme.textDark};
        }
    }
`;

const RightSide = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    small {
        font-size: 9px;
        font-weight: 400;
        color: ${theme.textDark};
        text-align: right;
    }

    span {
        margin-left: 10px;
        font-size: 28px;
        font-weight: 900;
        color: ${theme.textDark};
    }
`;


export { Container, LeftSide, RightSide };